import type { Prompt } from "@1js/pl-types";
import React from "react";
import { useFlightContext } from "../../hooks/useFlightContext";
import { useHandoffService } from "../../hooks/useHandoffService";
import type { HandlePromptsTabSelected } from "./AllPrompts.web.data";
import { useWorkgroups } from "./useWorkgroups.hook";

export type UseSuggestedPromptsType = {
  handlePromptsTabSelected: HandlePromptsTabSelected;
  onBookmarkToggled?: () => void;
  setDialogOpen: (isOpen: boolean) => void;
  onDelete?: (prompt: Prompt) => void;
};

export const useSuggestedPrompts = ({
  handlePromptsTabSelected,
  onBookmarkToggled,
  setDialogOpen,
  onDelete,
}: UseSuggestedPromptsType) => {
  const { isFlightActive } = useFlightContext();
  const { chooseBestProductForHandoff } = useHandoffService();
  useWorkgroups({ handlePromptsTabSelected });

  const handleBookmarkToggleOnClick = React.useCallback(() => {
    if (onBookmarkToggled) {
      onBookmarkToggled();
    }
  }, [onBookmarkToggled]);

  const handleOnDelete = React.useCallback(
    (prompt: Prompt) => {
      setDialogOpen(false);
      onDelete && onDelete(prompt);
    },
    [onDelete, setDialogOpen]
  );

  return {
    isFlightActive,
    handleBookmarkToggleOnClick,
    handleOnDelete,
    chooseBestProductForHandoff,
  };
};
